import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Wrapper } from "./PayRolePayCard.styled";
import { Checkbox } from "antd";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";

const PayRolePayCard = forwardRef(({ isSmall, pays, selectedPayeeToPay, handleCheckBoxAmount }, ref) => {
    const [isOpen, setIsOpen] = useState(false);
    useImperativeHandle(ref, () => ({
        closeDropDown() {
            setIsOpen(false);
        }
    }));
    return (
        <Wrapper xs={24} sm={24} lg={12} xl={12} xxl={12}>
            {pays && pays.length ? (
                <>
                    {pays.length > 1 ? (
                        <div className="payee-payrol-pay-multi-box">
                            <div className="payee-payrol-pay-box">
                                <div className="payee-payrol-pay-title">
                                    <div className="payee-payrol-pay-title-checkbox">
                                        <Checkbox checked={selectedPayeeToPay.includes(pays[0]._id)} onClick={() => handleCheckBoxAmount(pays[0]._id, pays[0].amount)} />
                                    </div>
                                    <div className="payee-payrol-pay-title-text">{pays[0].description}</div>
                                </div>
                                <div className="payee-payrol-pay-middle-container">
                                    <div className="payee-payrol-pay-text-box">
                                        {pays[0].lead.name}
                                    </div>
                                </div>
                                <div className="payee-payrol-pay-bottom-container">
                                    <div className="payee-payrol-pay-amount">${pays[0].amount}</div>
                                    {!isOpen && (<MdKeyboardArrowDown size={isSmall ? 26 : 30} cursor="pointer" color='#131f28' onClick={() => setIsOpen(true)} />)}
                                    {isOpen && (<MdKeyboardArrowUp size={isSmall ? 26 : 30} cursor="pointer" color='#131f28' onClick={() => setIsOpen(false)} />)}
                                </div>
                            </div>
                            {isOpen && (<div className="payee-payrol-pay-option-div">
                                {pays.slice(1).map((pay) => (
                                    <div className="payee-payrol-pay-box no-shadow">
                                        <div className="payee-payrol-pay-title">
                                            <div className="payee-payrol-pay-title-checkbox">
                                                <Checkbox checked={selectedPayeeToPay.includes(pay._id)} onClick={() => handleCheckBoxAmount(pay._id, pay.amount)} />
                                            </div>
                                            <div className="payee-payrol-pay-title-text">{pay.description}</div>
                                        </div>
                                        <div className="payee-payrol-pay-middle-container">
                                            <div className="payee-payrol-pay-text-box">
                                                {pay.lead.name}
                                            </div>
                                        </div>
                                        <div className="payee-payrol-pay-amount">${pay.amount}</div>
                                    </div>
                                ))}
                            </div>)}
                        </div>
                    ) : (
                        <div className="payee-payrol-pay-box">
                            <div className="payee-payrol-pay-title">
                                <div className="payee-payrol-pay-title-checkbox">
                                    <Checkbox checked={selectedPayeeToPay.includes(pays[0]._id)} onClick={() => handleCheckBoxAmount(pays[0]._id, pays[0].amount)} />
                                </div>
                                <div className="payee-payrol-pay-title-text">{pays[0].description}</div>
                            </div>
                            <div className="payee-payrol-pay-amount">${pays[0].amount}</div>
                        </div>
                    )}
                </>
            ) : (<></>)}

        </Wrapper>
    )
});

export default PayRolePayCard;
